import { updates } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

const typeStyle: Record<string, string> = {
  章节: "bg-primary-100 text-primary-800",
  同人: "bg-secondary-100 text-secondary-800",
  番外: "bg-accent-100 text-accent-900",
  设定: "bg-background-200 text-foreground-700",
  条目: "bg-background-200 text-foreground-700",
  预告: "bg-accent-100 text-accent-900",
};

export default function Updates() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <SectionHeading
          kicker="Updates"
          title="更新动态：最近的变更记录"
          desc="以时间线记录章节、同人、番外与设定条目的更新节奏，并标注内容形态。追更读者可以据此判断哪一部分值得优先查看。"
        />

        <ol className="mt-10 relative border-l border-background-300 ml-2 md:ml-4">
          {updates.map((item) => (
            <li key={item.title} className="relative pl-6 md:pl-8 pb-7 last:pb-0">
              <span className="absolute -left-[7px] top-1.5 w-3.5 h-3.5 rounded-full bg-accent-500 border-2 border-background-100" />
              <div className="flex flex-wrap items-center gap-2">
                <time className="text-xs font-medium text-foreground-500">{item.date}</time>
                <span className={`px-2.5 py-0.5 rounded-full text-xs whitespace-nowrap ${typeStyle[item.type] ?? "bg-background-200 text-foreground-700"}`}>
                  {item.type}
                </span>
                <span className="px-2.5 py-0.5 rounded-full text-xs whitespace-nowrap bg-background-50 border border-background-200 text-foreground-600">
                  {item.tag}
                </span>
              </div>
              <h3 className="mt-2 font-heading text-base md:text-lg font-semibold text-foreground-950 leading-snug">
                {item.title}
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}